'use client';

import { beginInstantRouteTransition } from '@/components/InstantRouteTransitionOverlay';
import { appRPC } from '@/lib/utils';
import { appendCampaignParamsToUrl } from '@/lib/persistCampaignParams';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

function notify(url: string) {
  appRPC('bridge', 'routeChanged', url);

  // try {
  //   const id = '__routeDebugBadge';
  //   let el = document.getElementById(id);
  //   if (!el) {
  //     el = document.createElement('div');
  //     el.id = id;
  //     el.style.cssText =
  //       'position:fixed;top:72px;right:8px;background:#111;color:#fff;padding:6px 8px;border-radius:6px;font:12px/1.2 system-ui,-apple-system,Segoe UI;z-index:2147483647;opacity:.9';
  //     document.body.appendChild(el);
  //   }
  //   el.textContent = `app ${url}`;
  // } catch {}
}

export default function NativeRouteBridge() {
  const router = useRouter();
  const pathname = usePathname() || '/';
  const search = useSearchParams()?.toString() || '';
  const lastUrlRef = useRef<string>('');
  const lastTsRef = useRef<number>(0);

  const notify = (url: string) => {
    const now = Date.now();
    if (url === lastUrlRef.current && now - lastTsRef.current < 800) return; // debounce
    lastUrlRef.current = url;
    lastTsRef.current = now;
    appRPC('bridge', 'routeChanged', url);
  };

  useEffect(() => {
    notify(location.pathname + location.search + location.hash);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const url = search ? `${pathname}?${search}` : pathname;
    notify(url);
  }, [pathname, search]);

  useEffect(() => {
    (window as any).__hzcNavigate = (rawUrl: string, mode: 'push' | 'replace' = 'push') => {
      try {
        if (!rawUrl) return false;
        let target = rawUrl;
        if (rawUrl.startsWith('http://') || rawUrl.startsWith('https://')) {
          const u = new URL(rawUrl);
          target = `${u.pathname}${u.search}${u.hash}`;
        }
        if (!target.startsWith('/')) {
          target = `/${target}`;
        }

        const href = appendCampaignParamsToUrl(target);
        beginInstantRouteTransition(href);
        if (mode === 'replace') {
          router.replace(href);
        } else {
          router.push(href);
        }
        return true;
      } catch (e) {
        return false;
      }
    };

    return () => {
      try {
        delete (window as any).__hzcNavigate;
      } catch (e) {}
    };
  }, [router]);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('hc:route:start'));
  }, [pathname]);

  return null;
}
